// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MainRouteImport } from './routes/_main'
import { Route as CrewRouteImport } from './routes/crew'
import { Route as GlutenfreiRouteImport } from './routes/glutenfrei'
import { Route as VeganRouteImport } from './routes/vegan'
import { Route as MainIndexRouteImport } from './routes/_main.index'
import { Route as MainSlugRouteImport } from './routes/_main.$slug'
import { Route as MainRouteRouteImport } from './routes/_main.Route'
import { Route as MainAngebotRouteImport } from './routes/_main.angebot'
import { Route as MainAwarenessRouteImport } from './routes/_main.awareness'
import { Route as MainBadgesRouteImport } from './routes/_main.badges'
import { Route as MainBookingRouteImport } from './routes/_main.booking'
import { Route as MainEventsRouteImport } from './routes/_main.events'
import { Route as MainInfosRouteImport } from './routes/_main.infos'
import { Route as MainLearnRouteImport } from './routes/_main.learn'
import { Route as MainLineupRouteImport } from './routes/_main.lineup'
import { Route as MainLogoRouteImport } from './routes/_main.logo'
import { Route as MainMitgliedsantragRouteImport } from './routes/_main.mitgliedsantrag'
import { Route as MainNuclinoSsoRouteImport } from './routes/_main.nuclino-sso'
import { Route as MainPlakateRouteImport } from './routes/_main.plakate'
import { Route as MainSpeisekarteRouteImport } from './routes/_main.speisekarte'
import { Route as CrewIndexRouteImport } from './routes/crew.index'
import { Route as CrewAuthReturnRouteImport } from './routes/crew.auth-return'
import { Route as CrewNoiseRouteImport } from './routes/crew.noise'
import { Route as CrewProdukteRouteImport } from './routes/crew.produkte'
import { Route as MainBookingApplicationTypeRouteImport } from './routes/_main.booking_.$applicationType'
import { Route as MainCardHashRouteImport } from './routes/_main.card.$hash'
import { Route as MainEventsIdRouteImport } from './routes/_main.events_.$id'
import { Route as MainLineupIndexRouteImport } from './routes/_main.lineup.index'
import { Route as MainLineupYearRouteImport } from './routes/_main.lineup.$year'
import { Route as MainMitgliedsantragDankeRouteImport } from './routes/_main.mitgliedsantrag_.danke'
import { Route as MainNewsSlugRouteImport } from './routes/_main.news.$slug'
import { Route as MainNewsArchivRouteImport } from './routes/_main.news.archiv'
import { Route as CrewBookingEventIdRouteImport } from './routes/crew.booking.$eventId'
import { Route as CrewNoiseIndexRouteImport } from './routes/crew.noise.index'
import { Route as CrewProdukteIndexRouteImport } from './routes/crew.produkte.index'
import { Route as CrewProdukteListIdRouteImport } from './routes/crew.produkte.$listId'
import { Route as MainBookingApplicationTypeDankeRouteImport } from './routes/_main.booking_.$applicationType_.danke'
import { Route as MainCardHashCrewRouteImport } from './routes/_main.card.$hash.crew'
import { Route as MainCardHashKultRouteImport } from './routes/_main.card.$hash.kult'
import { Route as MainLineupYearSlugRouteImport } from './routes/_main.lineup.$year_.$slug'
import { Route as MainSpendenQuittungIdRouteImport } from './routes/_main.spenden_.quittung.$id'
import { Route as CrewBookingEventIdApplicationIdRouteImport } from './routes/crew.booking.$eventId.$applicationId'
import { Route as CrewNoiseDeviceDeviceRouteImport } from './routes/crew.noise.device.$device'
import { Route as CrewNoiseProjectProjectIdRouteImport } from './routes/crew.noise.project.$projectId'
import { Route as CrewBookingEventIdApplicationIdContactRouteImport } from './routes/crew.booking.$eventId.$applicationId.contact'
import { Route as CrewNoiseProjectProjectIdIndexRouteImport } from './routes/crew.noise.project.$projectId.index'
import { Route as CrewNoiseProjectProjectIdListRouteImport } from './routes/crew.noise.project.$projectId.list'
import { Route as CrewNoiseProjectProjectIdMapRouteImport } from './routes/crew.noise.project.$projectId.map'

const MainRoute = MainRouteImport.update({
            id: '/_main',getParentRoute: () => rootRouteImport
          })
const CrewRoute = CrewRouteImport.update({
            id: '/crew',path: '/crew',getParentRoute: () => rootRouteImport
          })
const GlutenfreiRoute = GlutenfreiRouteImport.update({
            id: '/glutenfrei',path: '/glutenfrei',getParentRoute: () => rootRouteImport
          })
const VeganRoute = VeganRouteImport.update({
            id: '/vegan',path: '/vegan',getParentRoute: () => rootRouteImport
          })
const MainIndexRoute = MainIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MainRoute
          })
const MainSlugRoute = MainSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => MainRoute
          })
const MainRouteRoute = MainRouteRouteImport.update({
            id: '/Route',path: '/Route',getParentRoute: () => MainRoute
          })
const MainAngebotRoute = MainAngebotRouteImport.update({
            id: '/angebot',path: '/angebot',getParentRoute: () => MainRoute
          })
const MainAwarenessRoute = MainAwarenessRouteImport.update({
            id: '/awareness',path: '/awareness',getParentRoute: () => MainRoute
          })
const MainBadgesRoute = MainBadgesRouteImport.update({
            id: '/badges',path: '/badges',getParentRoute: () => MainRoute
          })
const MainBookingRoute = MainBookingRouteImport.update({
            id: '/booking',path: '/booking',getParentRoute: () => MainRoute
          })
const MainEventsRoute = MainEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => MainRoute
          })
const MainInfosRoute = MainInfosRouteImport.update({
            id: '/infos',path: '/infos',getParentRoute: () => MainRoute
          })
const MainLearnRoute = MainLearnRouteImport.update({
            id: '/learn',path: '/learn',getParentRoute: () => MainRoute
          })
const MainLineupRoute = MainLineupRouteImport.update({
            id: '/lineup',path: '/lineup',getParentRoute: () => MainRoute
          })
const MainLogoRoute = MainLogoRouteImport.update({
            id: '/logo',path: '/logo',getParentRoute: () => MainRoute
          })
const MainMitgliedsantragRoute = MainMitgliedsantragRouteImport.update({
            id: '/mitgliedsantrag',path: '/mitgliedsantrag',getParentRoute: () => MainRoute
          })
const MainNuclinoSsoRoute = MainNuclinoSsoRouteImport.update({
            id: '/nuclino-sso',path: '/nuclino-sso',getParentRoute: () => MainRoute
          })
const MainPlakateRoute = MainPlakateRouteImport.update({
            id: '/plakate',path: '/plakate',getParentRoute: () => MainRoute
          })
const MainSpeisekarteRoute = MainSpeisekarteRouteImport.update({
            id: '/speisekarte',path: '/speisekarte',getParentRoute: () => MainRoute
          })
const CrewIndexRoute = CrewIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CrewRoute
          })
const CrewAuthReturnRoute = CrewAuthReturnRouteImport.update({
            id: '/auth-return',path: '/auth-return',getParentRoute: () => CrewRoute
          })
const CrewNoiseRoute = CrewNoiseRouteImport.update({
            id: '/noise',path: '/noise',getParentRoute: () => CrewRoute
          })
const CrewProdukteRoute = CrewProdukteRouteImport.update({
            id: '/produkte',path: '/produkte',getParentRoute: () => CrewRoute
          })
const MainBookingApplicationTypeRoute = MainBookingApplicationTypeRouteImport.update({
            id: '/booking_/$applicationType',path: '/booking/$applicationType',getParentRoute: () => MainRoute
          })
const MainCardHashRoute = MainCardHashRouteImport.update({
            id: '/card/$hash',path: '/card/$hash',getParentRoute: () => MainRoute
          })
const MainEventsIdRoute = MainEventsIdRouteImport.update({
            id: '/events_/$id',path: '/events/$id',getParentRoute: () => MainRoute
          })
const MainLineupIndexRoute = MainLineupIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MainLineupRoute
          })
const MainLineupYearRoute = MainLineupYearRouteImport.update({
            id: '/$year',path: '/$year',getParentRoute: () => MainLineupRoute
          })
const MainMitgliedsantragDankeRoute = MainMitgliedsantragDankeRouteImport.update({
            id: '/mitgliedsantrag_/danke',path: '/mitgliedsantrag/danke',getParentRoute: () => MainRoute
          })
const MainNewsSlugRoute = MainNewsSlugRouteImport.update({
            id: '/news/$slug',path: '/news/$slug',getParentRoute: () => MainRoute
          })
const MainNewsArchivRoute = MainNewsArchivRouteImport.update({
            id: '/news/archiv',path: '/news/archiv',getParentRoute: () => MainRoute
          })
const CrewBookingEventIdRoute = CrewBookingEventIdRouteImport.update({
            id: '/booking/$eventId',path: '/booking/$eventId',getParentRoute: () => CrewRoute
          })
const CrewNoiseIndexRoute = CrewNoiseIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CrewNoiseRoute
          })
const CrewProdukteIndexRoute = CrewProdukteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CrewProdukteRoute
          })
const CrewProdukteListIdRoute = CrewProdukteListIdRouteImport.update({
            id: '/$listId',path: '/$listId',getParentRoute: () => CrewProdukteRoute
          })
const MainBookingApplicationTypeDankeRoute = MainBookingApplicationTypeDankeRouteImport.update({
            id: '/booking_/$applicationType_/danke',path: '/booking/$applicationType/danke',getParentRoute: () => MainRoute
          })
const MainCardHashCrewRoute = MainCardHashCrewRouteImport.update({
            id: '/crew',path: '/crew',getParentRoute: () => MainCardHashRoute
          })
const MainCardHashKultRoute = MainCardHashKultRouteImport.update({
            id: '/kult',path: '/kult',getParentRoute: () => MainCardHashRoute
          })
const MainLineupYearSlugRoute = MainLineupYearSlugRouteImport.update({
            id: '/$year_/$slug',path: '/$year/$slug',getParentRoute: () => MainLineupRoute
          })
const MainSpendenQuittungIdRoute = MainSpendenQuittungIdRouteImport.update({
            id: '/spenden_/quittung/$id',path: '/spenden/quittung/$id',getParentRoute: () => MainRoute
          })
const CrewBookingEventIdApplicationIdRoute = CrewBookingEventIdApplicationIdRouteImport.update({
            id: '/$applicationId',path: '/$applicationId',getParentRoute: () => CrewBookingEventIdRoute
          })
const CrewNoiseDeviceDeviceRoute = CrewNoiseDeviceDeviceRouteImport.update({
            id: '/device/$device',path: '/device/$device',getParentRoute: () => CrewNoiseRoute
          })
const CrewNoiseProjectProjectIdRoute = CrewNoiseProjectProjectIdRouteImport.update({
            id: '/project/$projectId',path: '/project/$projectId',getParentRoute: () => CrewNoiseRoute
          })
const CrewBookingEventIdApplicationIdContactRoute = CrewBookingEventIdApplicationIdContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => CrewBookingEventIdApplicationIdRoute
          })
const CrewNoiseProjectProjectIdIndexRoute = CrewNoiseProjectProjectIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CrewNoiseProjectProjectIdRoute
          })
const CrewNoiseProjectProjectIdListRoute = CrewNoiseProjectProjectIdListRouteImport.update({
            id: '/list',path: '/list',getParentRoute: () => CrewNoiseProjectProjectIdRoute
          })
const CrewNoiseProjectProjectIdMapRoute = CrewNoiseProjectProjectIdMapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => CrewNoiseProjectProjectIdRoute
          })





const MainLineupRouteChildren = {
  MainLineupYearRoute: MainLineupYearRoute,MainLineupIndexRoute: MainLineupIndexRoute,MainLineupYearSlugRoute: MainLineupYearSlugRoute
}

const MainLineupRouteWithChildren = MainLineupRoute._addFileChildren(MainLineupRouteChildren)




const MainCardHashRouteChildren = {
  MainCardHashCrewRoute: MainCardHashCrewRoute,MainCardHashKultRoute: MainCardHashKultRoute
}

const MainCardHashRouteWithChildren = MainCardHashRoute._addFileChildren(MainCardHashRouteChildren)



const MainRouteChildren = {
  MainSlugRoute: MainSlugRoute,MainRouteRoute: MainRouteRoute,MainAngebotRoute: MainAngebotRoute,MainAwarenessRoute: MainAwarenessRoute,MainBadgesRoute: MainBadgesRoute,MainBookingRoute: MainBookingRoute,MainEventsRoute: MainEventsRoute,MainInfosRoute: MainInfosRoute,MainLearnRoute: MainLearnRoute,MainLineupRoute: MainLineupRouteWithChildren,MainLogoRoute: MainLogoRoute,MainMitgliedsantragRoute: MainMitgliedsantragRoute,MainNuclinoSsoRoute: MainNuclinoSsoRoute,MainPlakateRoute: MainPlakateRoute,MainSpeisekarteRoute: MainSpeisekarteRoute,MainIndexRoute: MainIndexRoute,MainBookingApplicationTypeRoute: MainBookingApplicationTypeRoute,MainCardHashRoute: MainCardHashRouteWithChildren,MainEventsIdRoute: MainEventsIdRoute,MainMitgliedsantragDankeRoute: MainMitgliedsantragDankeRoute,MainNewsSlugRoute: MainNewsSlugRoute,MainNewsArchivRoute: MainNewsArchivRoute,MainBookingApplicationTypeDankeRoute: MainBookingApplicationTypeDankeRoute,MainSpendenQuittungIdRoute: MainSpendenQuittungIdRoute
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)




const CrewNoiseProjectProjectIdRouteChildren = {
  CrewNoiseProjectProjectIdListRoute: CrewNoiseProjectProjectIdListRoute,CrewNoiseProjectProjectIdMapRoute: CrewNoiseProjectProjectIdMapRoute,CrewNoiseProjectProjectIdIndexRoute: CrewNoiseProjectProjectIdIndexRoute
}

const CrewNoiseProjectProjectIdRouteWithChildren = CrewNoiseProjectProjectIdRoute._addFileChildren(CrewNoiseProjectProjectIdRouteChildren)



const CrewNoiseRouteChildren = {
  CrewNoiseIndexRoute: CrewNoiseIndexRoute,CrewNoiseDeviceDeviceRoute: CrewNoiseDeviceDeviceRoute,CrewNoiseProjectProjectIdRoute: CrewNoiseProjectProjectIdRouteWithChildren
}

const CrewNoiseRouteWithChildren = CrewNoiseRoute._addFileChildren(CrewNoiseRouteChildren)




const CrewProdukteRouteChildren = {
  CrewProdukteListIdRoute: CrewProdukteListIdRoute,CrewProdukteIndexRoute: CrewProdukteIndexRoute
}

const CrewProdukteRouteWithChildren = CrewProdukteRoute._addFileChildren(CrewProdukteRouteChildren)




const CrewBookingEventIdApplicationIdRouteChildren = {
  CrewBookingEventIdApplicationIdContactRoute: CrewBookingEventIdApplicationIdContactRoute
}

const CrewBookingEventIdApplicationIdRouteWithChildren = CrewBookingEventIdApplicationIdRoute._addFileChildren(CrewBookingEventIdApplicationIdRouteChildren)



const CrewBookingEventIdRouteChildren = {
  CrewBookingEventIdApplicationIdRoute: CrewBookingEventIdApplicationIdRouteWithChildren
}

const CrewBookingEventIdRouteWithChildren = CrewBookingEventIdRoute._addFileChildren(CrewBookingEventIdRouteChildren)



const CrewRouteChildren = {
  CrewAuthReturnRoute: CrewAuthReturnRoute,CrewNoiseRoute: CrewNoiseRouteWithChildren,CrewProdukteRoute: CrewProdukteRouteWithChildren,CrewIndexRoute: CrewIndexRoute,CrewBookingEventIdRoute: CrewBookingEventIdRouteWithChildren
}

const CrewRouteWithChildren = CrewRoute._addFileChildren(CrewRouteChildren)

const rootRouteChildren = {
  MainRoute: MainRouteWithChildren,CrewRoute: CrewRouteWithChildren,GlutenfreiRoute: GlutenfreiRoute,VeganRoute: VeganRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)